import styled from "styled-components";

export const PlayerSelectionStyle = {
	PlayerSection: styled.section`
        --dp-bg: #291307;
        --dp-panel: #341a0c;
        --dp-border: #9b4b16;
        --dp-orange: #e67821;
        --dp-text: #f5c18d;

        position: relative;
        width: 515px;
        max-width: 100%;
        height: 130px;
        box-sizing: border-box;
        isolation: isolate;

        font-family: "Courier New", monospace;
        color: var(--dp-text);

        /* Äußere technische Kontur */

        &::before {
            content: "";
            position: absolute;
            inset: 0;
            z-index: -1;

            background: linear-gradient(
                    180deg,
                    #b45b19 0%,
                    #e27a21 45%,
                    #8a3c0f 100%
            );

            clip-path: polygon(
                    4% 0,
                    44% 0,
                    47% 7%,
                    96% 7%,
                    100% 16%,
                    100% 87%,
                    98% 95%,
                    4% 95%,
                    0 84%,
                    0 17%
            );
        }

        /* Dunkle Innenfläche mit abgeschrägten Ecken */

        &::after {
            content: "";
            position: absolute;
            inset: 1px;
            z-index: -1;

            background: linear-gradient(
                    135deg,
                    #3b1d0c 0%,
                    #2b1409 55%,
                    #231007 100%
            );

            clip-path: polygon(
                    4% 0,
                    44% 0,
                    47% 7%,
                    96% 7%,
                    100% 16%,
                    100% 87%,
                    98% 95%,
                    4% 95%,
                    0 84%,
                    0 17%
            );
        }
	`,

	Inner: styled.div`
        position: absolute;
        inset: 12px 20px 13px 24px;
        padding-top: 10px;
        padding-bottom: 10px;
	`,

	SectionLabel: styled.label`
        display: block;
        margin-bottom: 8px;

        color: #e87925;
        font-family: "Courier New", monospace;
        font-size: 13px;
        font-weight: 700;
        letter-spacing: 2.2px;
        line-height: 17px;
        text-transform: uppercase;

        text-shadow: 0 0 8px rgba(230, 112, 26, 0.22);
	`,

	SelectFrame: styled.div`
        position: relative;
        width: 100%;
        height: 49px;

        border: 1px solid #a6571e;
        background: #1c0e06;

        box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.4),
        inset 0 1px 8px rgba(0, 0, 0, 0.3),
        0 0 8px rgba(205, 96, 22, 0.08);

        &::before {
            content: "";
            position: absolute;
            top: -1px;
            left: 0;
            width: 100%;
            height: 1px;
            background: linear-gradient(
                    90deg,
                    #b96829,
                    #7d3b12 80%
            );
            pointer-events: none;
        }
	`,

	NativeSelect: styled.select`
        appearance: none;
        -webkit-appearance: none;

        width: 100%;
        height: 100%;
        padding: 0 45px 0 20px;

        border: 0;
        border-radius: 0;
        outline: none;
        background: transparent;

        color: #f5c18d;
        font-family: Arial, sans-serif;
        font-size: 14px;
        font-weight: 400;

        cursor: pointer;

        &:focus-visible {
            outline: 1px solid #f29a40;
            outline-offset: -3px;
        }

        option {
            background: #251207;
            color: #f5c18d;
        }
	`,

	Chevron: styled.svg`
        position: absolute;
        top: 50%;
        right: 13px;
        width: 13px;
        height: 13px;

        transform: translateY(-50%);
        pointer-events: none;

        fill: none;
        stroke: #f2c28e;
        stroke-width: 2.4;
        stroke-linecap: square;
        stroke-linejoin: miter;
	`
}